<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    {{getDemoUrlDetail}}
    <div class="form-group">
      <label class="label-form" for="title">Document Title<span style="color: red">*</span>:</label>
                    <input type="text" class="form-control" id="title" v-model="postForm.title" placeholder="Enter Title of the Document">
      
    </div>
    <div class="form-group">
      <label class="label-form">Document<span style="color: red">*</span>:</label>
      <div class="form-control" style="padding:3px">
                        <input type="file" ref="caption" @change="handleCaptionUpload()">
                    </div>
      
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      
      <button  type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
    
      <button  type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-primary btn-sm ml-1" @click="uploadDocument">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Submit
      </button>

      

    </div>

    <table class="table table-bordered table-hover  mt-5 text-center">
            <colgroup>
              <col class="col-md-4" />
              <col class="col-md-12" />
            </colgroup>
            <tbody>
              <tr>
                <th>Document Title</th>
                <th>Action</th>
              </tr>
              
              <tr class="mt-2" v-for="doc in orgDocs">
                
                <td  style="width: 80%;"> <p style="white-space: break-spaces">{{doc.document_title.substr(0,20)}}</p> </td>
               
                <td  style="width: 20%;">
                  <div class="btn-group">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                      <span class="fas fa-ellipsis-v"></span>
                    </a>
                    <ul class="dropdown-menu" style="min-width: 12rem !important">
                      <a class="dropdown-item" @click="downloadDocument(doc)">Download</a>
                      <a class="dropdown-item " style="color: rgb(247, 7, 7);" @click="deleteDocument(doc)">Delete</a>
                    </ul>
                  </div>
                </td>
              </tr>
              <h5 style="text-align: center; position: absolute; transform: translateX(130px); margin-top: 24px;" v-if="orgDocs.length === 0">
      No Document's found.
    </h5>
            </tbody>
          </table>

        <!-- <div class="card" v-for="doc in orgDocs">
                <img src="/doc.png" alt="Avatar" style="width:100%">
                <p class="text-center">{{doc.document_title.substr(0,20)}}</p>
                <div class="container">
                    <button type="button" @click="downloadDocument(doc)" class="btn btn-primary btn-sm download-btn">Download</button>
                    <button type="button" class="btn btn-warning text-dark btn-sm delete-btn" @click="deleteDocument(doc)">Delete</button>
                </div>
        </div>
            <div v-if="orgDocs.length === 0">
                <h6 class="text-center">No Documents Found in this Organization</h6>
            </div> -->



  </form>

  

</template>
<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        isMiniLoading: false,
        postForm: {},
        orgDocs: {},
        id:"",
      };
    },
   
created: function () {
            // Upon page creation setting data like org_id etc
            this.postForm.organization_id = this.formData.org_id;

            this.getAllDocs();
        },


    methods: {

        handleCaptionUpload() {
                this.postForm.caption = this.$refs.caption.files[0];
            },

            

      uploadDocument() {
                // Show warning message if Title or document is not given
                this.isMiniLoading=true;
                
                if(this.postForm.title == null || this.postForm.caption == null || this.postForm.caption == '' || this.postForm.title == ''){
                    this.$toast.warning("Fill All Required Fields");
                    this.isMiniLoading = false;

                }
                else {
                    let formData = new FormData();
                    formData.append('title', this.postForm.title);
                    formData.append('organization_id', this.postForm.organization_id);
                    formData.append('caption', this.postForm.caption);

                    axios.post('/admin/organization/document', formData)
                        .then((org) => {
                            if(org.data.status==422){
                                this.$toast.warning(org.data.message);
                                this.isMiniLoading = false;
                            }
                            // send successful message
                            if(org.status==201){
                                this.$toast.success(`Document has been added successfully`);
                                this.isMiniLoading = false;
                            // reset post
                            this.getAllDocs();
                            this.postForm.title = null;
                            this.postForm.title = '';
                            this.postForm.caption = null;
                            this.postForm.caption = '';
                            this.$refs.caption.value = '';
                            this.$refs.caption.value = null;
                            
                            
                            this.getAllDocs();
                            }
                            
                        })
                        
                }
            },
            getAllDocs() {
                axios.get('admin/organization/document/' + this.postForm.organization_id)
                    .then((response) => {
                        this.orgDocs = response.data.organization;
                    });
            },
            getMimetype(fileExtension) {
                switch (fileExtension) {
                    case 'png':
                        return 'image/png';
                    case 'gif':
                        return 'image/gif';
                    case 'pdf':
                        return 'application/pdf';
                    case 'jpg':
                        return 'image/jpeg';
                    case 'xls':
                    case 'xlt':
                    case 'xla':
                        return 'application/vnd.ms-excel';
                    case 'doc':
                        return 'application/msword';
                    case 'docx':
                    case 'dotx':
                        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                }
            },
            downloadDocument(doc) {
                axios.post('/admin/organization/document/download', doc, { responseType: 'arraybuffer' })
                    .then((response) => {
                        // Extract File extension so its related mimeType can be given while creating blob
                        var fileExt = doc.slug.split('.').pop();
                        let mimeType = this.getMimetype(fileExt);

                        // It is necessary to create a new blob object with mime-type explicitly set
                        var newBlob = new Blob([response.data], { type: mimeType });
                        const data = window.URL.createObjectURL(newBlob);
                        var link = document.createElement('a');
                        link.href = data;
                        link.download = doc.document_title;
                        link.click();

                        // Downloading File here
                        setTimeout(function () {
                            window.URL.revokeObjectURL(data)
                        }, 500)
                    })
                    .catch((error) => {
                        // send error message
                        this.$toast.error(error.response.data.message);
                    });
            },

            deleteDocument(doc) {
                    this.delete(doc);
            },

            delete(document) {
                axios.post('/admin/organization/document/delete', document)
                    .then((message) => {
                        // send successful message
                        this.$toast.error(message.data.message);
                        this.getAllDocs();
                    })
                    .catch((error) => {
                        // send error message
                        this.$toast.error(error.response.data.message);
                    });
            },
    },
  };
</script>